<template>
	<router-link
		tag="div"
		class="menu-item"
		:to="itemPagePath"
		@click.native="productClicked()"
	>
		<div class="menu-item-left">
			<div>
				<div class="item-name">{{ item.name }}</div>
				<div class="item-desc">{{ item.description }}</div>
				<div class="item-price-wrapper">
					<div class="item-price">{{ item.price | currency }}</div>
					<div
						v-if="showPreorderOnlyLabel"
						class="
							pill pill-orange
							preorder-only-label
							ellipsify-text
						"
					>
						<i class="sk-icon-stopwatch-regular"></i>
						Pre Order Exclusive
					</div>
				</div>
			</div>
		</div>
		<div
			class="item-img"
			v-if="hasImage"
			:style="{ backgroundImage: `url(${backgroundPath})` }"
		></div>
	</router-link>
</template>

<script>
import { MenuType } from "@reef-os/utils/enums/menuType"
import { UniqueProductLabelId } from "@/enums/UniqueProductLabelId"
import menuItemMixin from "@/mixins/menu-item-mixin"

export default {
	name: "MenuItem",
	mixins: [menuItemMixin],
	computed: {
		showPreorderOnlyLabel() {
			const hasPreorderOnlyLabel =
				this.item &&
				this.item.labels &&
				this.item.labels.some(
					(label) => label.id == UniqueProductLabelId.PREORDER_ONLY
				)
			const isEventMenu = this.item.menu_type == MenuType.POPUP
			return hasPreorderOnlyLabel && isEventMenu
		}
	}
}
</script>

<style scoped>
.menu-item {
	background: #ffffff;
	border: 1px solid var(--gR-white2);
	border-radius: 5px;
	min-height: 110px;
	margin-bottom: 10px;
	display: flex;
	justify-content: space-between;
}

.menu-item-left {
	display: flex;
	justify-content: space-between;
	padding: 15px 10px;
	flex: 1;
	min-width: 0;
}

.menu-item-left > div {
	min-width: 0;
}

.menu-item-left > div:first-child {
	width: 100%;
}

.item-price-wrapper {
	margin-right: 15px;
	margin-top: 14px;
	display: flex;
	justify-content: space-between;
}

.item-price-wrapper .preorder-only-label {
	margin-left: 10px;
}

.item-price-wrapper .preorder-only-label i {
	margin-right: 10px;
	color: var(--gR-white);
}

.item-price {
	color: var(--gR-base-90);
	font-size: 14px;
	font-weight: 600;
}

.item-img {
	width: 34%;
	background-position: center;
	background-size: cover;
	margin: 5px;
	border-radius: 5px;
}

.item-name,
.item-desc {
	max-width: 95%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.item-name {
	color: var(--gR-base-90);
	font-size: 14px;
	font-weight: 700;
	margin-bottom: 10px;
}

.item-desc {
	color: var(--sk-grey3);
	font-size: 12px;
}
</style>